// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__2UA4B"};